import { TradeLeadCalculator } from "@/components/TradeLeadCalculator";
import { createFileRoute } from "@tanstack/react-router";
import { IndustryMarketingPage, industryMarketingHead, type IndustryFAQ } from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  { q: "How do tree service companies get more leads in Colorado?", a: "Tuned Google Business Profile + local SEO so you show up in the Map Pack for 'tree removal near me' and storm-response searches, backed by a fast mobile site. We layer Google Ads during windstorm and beetle-kill surges." },
  { q: "What's the best marketing channel for a Colorado tree service?", a: "Local SEO + Google reviews — high intent, low cost-per-lead. Google Ads is essential during storm response. GEO AI is critical for ChatGPT recommendations." },
  { q: "How long does tree service SEO take?", a: "Most see Map Pack movement in 60–120 days. Storm-season terms can rank faster if pages are published 60 days before the season hits." },
  { q: "Do you work outside Colorado Springs?", a: "Yes — Denver, Fort Collins, Boulder, Springs, Pueblo, Castle Rock, Parker, Lone Tree, Highlands Ranch, Greenwood Village, and everywhere in between." },
  { q: "SEO vs Google Ads first?", a: "Ads for this week. SEO for long-term. Most successful Colorado tree services run both." },
];

export const Route = createFileRoute("/tree-service-marketing-colorado")({
  head: () => industryMarketingHead("Tree Service", "tree service", "tree-service-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry="Tree Service"
      industryLower="tree service"
      slug="tree-service-marketing-colorado"
      extraSections={<TradeLeadCalculator industry="Tree Service" defaultJob={1800} />}
      subheadline="We help Colorado tree service companies fill storm-response calls, scheduled trimming, and removal work year-round."
      painPoints={[
        "Storm response calls go to whoever ranks first when the wind hits",
        "Scheduled trimming books up the schedule but doesn't show in Google",
        "Out-of-state storm chasers flood the Map Pack after every windstorm",
      ]}
      serviceDescriptions={{
        seo: "Rank for tree removal, trimming, stump grinding, and emergency storm response across every Colorado market.",
        googleMaps: "Dominate the Map Pack so urgent 'tree removal near me' calls come to you first.",
        webDesign: "Fast, mobile-first tree service sites with one-tap calling and instant quote forms.",
        ppc: "Profitable Google Ads tuned to storm season, removal jobs, and recurring trimming routes.",
        geoAi: "Get cited when Coloradans ask ChatGPT 'best arborist near me' or 'how much to remove a tree'.",
        socialMedia: "Before-and-after photo content that wins residential and HOA contracts.",
      }}
      testimonial={{ quote: "After the September windstorm we were booked solid for six weeks straight thanks to the SEO work they did over the summer.", role: "Tree Service Owner", city: "Colorado Springs" }}
      faqs={FAQS}
      cityHubLinks={[
        { to: "/colorado-springs", label: "Tree service marketing in Colorado Springs", description: "Help Springs tree services own the Map Pack neighborhood by neighborhood." },
        { to: "/denver-digital-marketing", label: "Tree service marketing in Denver", description: "Compete in Colorado's largest market — neighborhood by neighborhood." },
        { to: "/castle-rock-digital-marketing", label: "Tree service marketing in Castle Rock", description: "Premium residential and HOA work across Castle Rock and Castle Pines." },
      ]}
    />
  ),
});
